import React from "react";

const Target = ({
  height = "22",
  width = "22",
  viewBox = "0 0 22 22",
  color = "#000"
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox={viewBox}
  >
    <g fill="none" fillRule="evenodd" transform="translate(-1 -1)">
      <polygon points="0 0 24 0 24 24 0 24" />
      <path
        fill={color}
        fillRule="nonzero"
        d="M12,8 C9.790861,8 8,9.790861 8,12 C8,14.209139 9.790861,16 12,16 C14.209139,16 16,14.209139 16,12 C16,9.790861 14.209139,8 12,8 L12,8 Z M20.94,11 C20.4713318,6.82434654 17.1756535,3.52866825 13,3.06 L13,1 L11,1 L11,3.06 C6.82434654,3.52866825 3.52866825,6.82434654 3.06,11 L1,11 L1,13 L3.06,13 C3.52866825,17.1756535 6.82434654,20.4713318 11,20.94 L11,23 L13,23 L13,20.94 C17.1756535,20.4713318 20.4713318,17.1756535 20.94,13 L23,13 L23,11 L20.94,11 Z M12,19 C8.13400675,19 5,15.8659932 5,12 C5,8.13400675 8.13400675,5 12,5 C15.8659932,5 19,8.13400675 19,12 C19,13.8565154 18.2625021,15.6369928 16.9497475,16.9497475 C15.6369928,18.2625021 13.8565154,19 12,19 Z"
      />
    </g>
  </svg>
);

export default Target;
